import BaseRepository from "@/baseRepository/BaseRepository";
const resource = `/api/v1/unitofmeasurements`;

export default {
  getUnitOfMeasurementsFilter(baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.get(`${resource}/filter`, {
      baseURL,
      headers,
      params
    });
  },
  getUnitOfMeasurementsList(baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.get(`${resource}`, {
      baseURL,
      headers,
      params
    });
  },
};